import {i18n} from '../i18n';

export const i18nLocaleCompare = (a: string, b: string) =>
	Intl.Collator(i18n.language).compare(a, b);

export default i18nLocaleCompare;
